import { useLanguage } from "../../hooks/LanguageProvider";
import { Container, Cover, Subtitle, Title } from "./styles";

interface PillCardProps {
  image: string;
  title: string;
}
export const PillCard: React.FC<PillCardProps> = ({ image, title }) => {
  const { language } = useLanguage();

  return (
    <Container className="justify-content-center text-center">
      <div className="d-flex justify-content-center text-center">
        <Cover style={{ backgroundImage: `url(${image})` }} />
      </div>
      <Title className="text-center">{title}</Title>
      <Subtitle>+ 2 {language === "US" ? "years" : "anos"}</Subtitle>
    </Container>
  );
};
